module.exports = __webpack_public_path__ + "img/mingyong49.7ca755db.png";